import { environment } from '@pgaoc/shared-lib';

class MemberAuth {
  static login(): string {
    return `${environment.mainServiceUrl}memberportal/members/login`;
  }
  static refreshSession(memberId: number): string {
    return `${environment.mainServiceUrl}memberportal/members/${memberId}/refreshsession`;
  }
  static resetPassword(memberId: number): string {
    return `${environment.mainServiceUrl}memberportal/members/${memberId}/forgotpassword`;
  }
  static setNewPassword(memberId: number): string {
    return `${environment.mainServiceUrl}memberportal/members/${memberId}/resetforgottenpassword`;
  }
  static resendWelcomeEmail(email: string): string {
    return `${environment.mainServiceUrl}memberportal/members/${encodeURIComponent(email)}/resendwelcomeemail`;
  }
}

class MembershipApplication {
  static createMembershipApplication(): string {
    return `${environment.mainServiceUrl}memberportal/membershipapplications`;
  }
  static createMembershipReapplicationApplication(): string {
    return `${environment.mainServiceUrl}memberportal/membershipreapplicationapplications`;
  }
  static createMembershipReinstatementApplication(): string {
    return `${environment.mainServiceUrl}memberportal/membershipreinstatementapplications`;
  }
}

class Members {
  static getMember(memberId: number): string {
    return `${environment.mainServiceUrl}odata/memberportal/members/${memberId}`;
  }
  static updateMember(memberId: number): string {
    return `${environment.mainServiceUrl}memberportal/members/${memberId}`;
  }
  static getMembers(): string {
    return `${environment.mainServiceUrl}odata/memberportal/members`;
  }
  static memberSearch(): string {
    return `${environment.mainServiceUrl}odata/memberportal/membersearch`;
  }
}

class Championships {
  static getChampionships(): string {
    return `${environment.mainServiceUrl}odata/memberportal/championships`;
  }

  static getChampionship(championshipId: number): string {
    return `${environment.mainServiceUrl}odata/memberportal/championships/${championshipId}`;
  }

  static getChampionshipSummaries(): string {
    return `${environment.mainServiceUrl}odata/memberportal/championshipsummaries`;
  }

  static updateChampionshipParticipant(championshipId: number, championshipParticipantId: number): string {
    return `${environment.mainServiceUrl}memberportal/championships/${championshipId}/participants/${championshipParticipantId}`;
  }

  static individualRegistration(championshipId: number): string {
    return `${environment.mainServiceUrl}memberportal/championships/${championshipId}/individualregistrations`;
  }

  static waitlistedIndividualRegistration(championshipId: number): string {
    return `${environment.mainServiceUrl}memberportal/championships/${championshipId}/waitlistedindividualregistrations`;
  }

  static teamRegistration(championshipId: number): string {
    return `${environment.mainServiceUrl}memberportal/championships/${championshipId}/teamregistrations`;
  }

  static waitlistedTeamRegistration(championshipId: number): string {
    return `${environment.mainServiceUrl}memberportal/championships/${championshipId}/waitlistedteamregistrations`;
  }
}

class Events {
  static getEvents(): string {
    return `${environment.mainServiceUrl}odata/memberportal/events`;
  }

  static getEvent(eventId: number): string {
    return `${environment.mainServiceUrl}odata/memberportal/events/${eventId}`;
  }

  static getEventSummaries(): string {
    return `${environment.mainServiceUrl}odata/memberportal/eventsummaries`;
  }

  static updateEventParticipant(eventId: number, eventParticipantId: number): string {
    return `${environment.mainServiceUrl}memberportal/events/${eventId}/participants/${eventParticipantId}`;
  }

  static individualRegistration(eventId: number): string {
    return `${environment.mainServiceUrl}memberportal/events/${eventId}/individualregistrations`;
  }

  static waitlistedIndividualRegistration(eventId: number): string {
    return `${environment.mainServiceUrl}memberportal/events/${eventId}/waitlistedindividualregistrations`;
  }
}

export class Endpoints {
  static MemberAuth = MemberAuth;
  static MembershipApplications = MembershipApplication;
  static Members = Members;
  static Championships = Championships;
  static Events = Events;
}
